"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavStepperItem = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../VisuallyHidden/index.js");
var _Icon = require("./Icon.js");
var _Step = require("./Step.js");
var _Text = require("./Text.js");
var _excluded = ["active", "visited", "condensed", "children"];
/**
 * NavStepperItem is a step in the NavStepper.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navstepper-navstepperitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#nav-stepper) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavStepperItem) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=0-682&t=OevvE6IpFUWE6egI-1)
 */
var NavStepperItem = exports.NavStepperItem = function NavStepperItem(_ref) {
  var active = _ref.active,
    visited = _ref.visited,
    condensed = _ref.condensed,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Step.Step, Object.assign({
    $active: active,
    $visited: visited,
    $condensed: condensed,
    "aria-current": active ? 'step' : undefined
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavStepperItem
  }), condensed ? /*#__PURE__*/_react["default"].createElement(_index.VisuallyHidden, null, children) : /*#__PURE__*/_react["default"].createElement(_Text.VisibleText, {
    variant: "bodyMediumBold",
    $active: active
  }, children, " ", /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    "aria-hidden": "true"
  })));
};